import React, {useEffect, useState} from "react";
import CommonNoteModal from "../../../features/order/modal/CommonNoteModal";

// Define prop types
interface NoteAddOrUpdateModalProps {
    show: boolean;
    title: string;
    setShow: (show: boolean) => void;
    noteObj?: any;
    type: string;
    relationalId: any;
    btnName: string;
    isFulfillmentNotes?: boolean;
    parentAccountData?: any;
    length?: number;
    handleSubmit?: any;
    noteBody?: any;
    setNoteBody?: any;
    isLoading?: any;
    isExternalInternal?: boolean;
    external?: boolean;
    setExternal?: any
}

const NotesUpdateOrAddModal: React.FC<NoteAddOrUpdateModalProps> = ({
                                                                        show,
                                                                        title,
                                                                        setShow,
                                                                        noteObj = null,
                                                                        type,
                                                                        btnName,
                                                                        isFulfillmentNotes = false,
                                                                        parentAccountData = null,
                                                                        length = 1,
                                                                        handleSubmit,
                                                                        noteBody,
                                                                        setNoteBody,
                                                                        isLoading,
                                                                        external = false,
                                                                        setExternal,
                                                                        isExternalInternal = false
                                                                    }: NoteAddOrUpdateModalProps) => {

    const [targetCert, setTargetCert] = useState<string>("BOTH");
    const [saveAsCanned, setSaveAsCanned] = useState<boolean>(false);
    const [yellowHighlight, setYellowHighlight] = useState<boolean>(false);
    const [redColor, setRedColor] = useState<boolean>(false);
    const [isBold, setIsBold] = useState<boolean>(false);
    const [accountNumber, setAccountNumber] = useState<any>(null);

    useEffect(() => {
        if (noteObj !== null) {
            setNoteBody(noteObj?.message !== undefined ? noteObj?.message : noteObj?.comment);
            setAccountNumber(noteObj?.accountNumber !== undefined ? noteObj?.accountNumber : null);
            setIsBold(noteObj?.bold !== undefined ? noteObj?.bold : null);
            setTargetCert(noteObj?.targetCert !== undefined ? noteObj?.targetCert : null);
            setRedColor(noteObj?.redColor !== undefined ? noteObj?.redColor : null);
            setYellowHighlight(noteObj?.yellowHighlight !== undefined ? noteObj?.yellowHighlight : null);
        }
    }, [noteObj]);

    function dismissModal(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        setShow(false);
        setNoteBody("");
    }

    return (
        <>
            <CommonNoteModal
                targetCert={targetCert}
                setTargetCert={setTargetCert}
                noteBody={noteBody}
                title={title}
                setShow={setShow}
                show={show}
                setNoteBody={setNoteBody}
                onSubmit={handleSubmit}
                dismissModal={dismissModal}
                type={type}
                saveAsCanned={saveAsCanned}
                setSaveAsCanned={setSaveAsCanned}
                isCertificateNote={false}
                yellowHighlight={yellowHighlight}
                setYellowHighlight={setYellowHighlight}
                redColor={redColor}
                setRedColor={setRedColor}
                bold={isBold}
                setBold={setIsBold}
                btnName={btnName}
                isFulfillmentNotes={isFulfillmentNotes}
                accountNumber={accountNumber}
                setAccountNumber={setAccountNumber}
                parentAccountData={parentAccountData}
                isLoading={isLoading}
                isExternalInternal={isExternalInternal}
                external={external}
                setExternal={setExternal}
            />


        </>
    );
};

export default NotesUpdateOrAddModal;
